import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router';

//Components
import Drawer from 'devextreme-react/drawer';
import ScrollView from 'devextreme-react/scroll-view';
import { Template } from 'devextreme-react/core/template';

import { Header, SideNavigationMenu, Footer } from '../../components';

//css
import './side-nav-outer-toolbar.scss';

//utils
import { sizes, screenSubscribe, screenUnsubscribe } from '../../utils/media-query';
import { menuPreInitPatch } from '../../utils/patches';


import {
    menu_entries_admin, menu_entries_user, menu_entries_anon,
    panel_menu_entries_authenticated, panel_menu_entries_anon
} from '../../settings/app-routes';

class SideNavOuterToolbar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            menu_entries: menu_entries_anon,
            panel_menu_entries: panel_menu_entries_anon,
            menuOpened: sizes()['screen-large'],
            temporaryMenuOpened: false,
            ...this.drawerConfig
        };

        this.menuPatch = menuPreInitPatch(this);
    }

    componentDidMount() {
        screenSubscribe(this.updateDrawer);

        // cambio le menu_entries in base all'utente loggato
        if (this.props.codiceUtente === 'anonymous')
            this.setState({
                menu_entries: menu_entries_anon,
                panel_menu_entries: panel_menu_entries_anon
            });
        else if (this.props.codiceUtente === 'CODICEADMIN')
            this.setState({
                menu_entries: menu_entries_admin,
                panel_menu_entries: panel_menu_entries_authenticated
            });
        else this.setState({
            menu_entries: menu_entries_user,
            panel_menu_entries: panel_menu_entries_authenticated
        });
    }

    componentDidUpdate(propsPrecedenti) {
        // cambio le menu_entries in base all'utente loggato
        if (this.props.codiceUtente !== propsPrecedenti.codiceUtente) {
            if (this.props.codiceUtente === 'anonymous')
                this.setState({
                    menu_entries: menu_entries_anon,
                    panel_menu_entries: panel_menu_entries_anon
                });
            else if (this.props.codiceUtente === 'CODICEADMIN')
                this.setState({
                    menu_entries: menu_entries_admin,
                    panel_menu_entries: panel_menu_entries_authenticated
                });
            else this.setState({
                menu_entries: menu_entries_user,
                panel_menu_entries: panel_menu_entries_authenticated
            });
        }
    }

    componentWillUnmount() {
        screenUnsubscribe(this.updateDrawer);
    }

    render() {
        const { title, location } = this.props;
        const { menuOpened, menuMode, shaderEnabled, menuRevealMode, minMenuSize, menu_entries, panel_menu_entries } = this.state;

        return (
            <div className={'side-nav-outer-toolbar'}>
                <Header
                    className={'layout-header'}
                    menuToggleEnabled
                    toggleMenu={() =>
                        this.setState({ menuOpened: !this.state.menuOpened })
                    }
                    title={title}
                    panelMenuItems={panel_menu_entries}
                />

                <Drawer
                    className={'layout-body' + this.menuPatch.cssClass}
                    position={'before'}
                    closeOnOutsideClick={this.closeDrawer}
                    openedStateMode={menuMode}
                    revealMode={menuRevealMode}
                    minSize={minMenuSize}
                    maxSize={250}
                    shading={shaderEnabled}
                    opened={menuOpened}
                    template={'menu'}
                >
                    <ScrollView className={'with-footer'}>
                        <div className={'content'}>
                            {React.Children.map(this.props.children, item => {
                                return item.type !== Footer && item;
                            })}
                        </div>
                        <div className={'content-block'}>
                            {React.Children.map(this.props.children, item => {
                                return item.type === Footer && item;
                            })}
                        </div>
                    </ScrollView>
                    <Template name={'menu'}>
                        <SideNavigationMenu
                            items={menu_entries}
                            compactMode={!menuOpened}
                            selectedItem={location.pathname}
                            className={'dx-swatch-additional'}
                            selectedItemChanged={this.navigationChanged}
                            openMenu={this.navigationClick}
                            onMenuReady={this.menuPatch.onReady}
                        />
                    </Template>
                </Drawer>
            </div>
        );
    }

    closeDrawer = () => {
        if (!this.state.shaderEnabled) {
            return false;
        }

        this.setState({ menuOpened: false });
        return true;
    }

    updateDrawer = () => {
        this.setState({ ...this.drawerConfig });
    };

    get drawerConfig() {
        const isXSmall = sizes()['screen-x-small'];
        const isLarge = sizes()['screen-large'];

        return {
            menuMode: isLarge ? 'shrink' : 'overlap',
            menuRevealMode: isXSmall ? 'slide' : 'expand',
            minMenuSize: isXSmall ? 0 : 60,
            shaderEnabled: !isLarge
        };
    }

    get hideMenuAfterNavigation() {
        const { menuMode, temporaryMenuOpened } = this.state;
        return menuMode === 'overlap' || temporaryMenuOpened;
    }

    navigationChanged = event => {
        const path = event.itemData.path;
        const pointerEvent = event.event;

        console.log(path);

        if (path === '/Identity/Account/Users') window.location.href = path;

        else
            if (path && this.state.menuOpened) {
                if (event.node.selected) {
                    pointerEvent.preventDefault();
                } else {
                    this.props.history.push(path);
                }

                if (this.hideMenuAfterNavigation) {
                    this.setState({
                        menuOpened: false,
                        temporaryMenuOpened: false
                    });
                    pointerEvent.stopPropagation();
                }
            } else {
                pointerEvent.preventDefault();
            }
    };

    navigationClick = () => {
        this.setState(({ menuOpened }) => {
            return !menuOpened
                ? {
                    temporaryMenuOpened: true,
                    menuOpened: true
                }
                : {};
        });
    };
}

SideNavOuterToolbar.propTypes = {
    // getLoggedUser: PropTypes.func.isRequired,
    // getLoggedUserRequestStatus: PropTypes.string.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    // getLoggedUserRequestStatus: state['logged-user'].status,

    // username: state['logged-user'].username,
    codiceUtente: state['logged-user'].codiceUtente,
    // IsAuthenticated: state['logged-user'].IsAuthenticated,
});

export default connect(mapStateToProps/*, mapDispatchToProps*/)(withRouter(SideNavOuterToolbar));
